/**
 * Pricing Domain Constants
 */

/**
 * Default VAT rate for Saudi Arabia
 */
export const DEFAULT_VAT_RATE = 15

/**
 * Default currency
 */
export const DEFAULT_CURRENCY = 'SAR' as const

/**
 * Supported currencies
 */
export const SUPPORTED_CURRENCIES = ['SAR', 'USD', 'EUR'] as const

/**
 * Packaging types
 */
export const PACKAGING_TYPES = {
  BAGS: 'bags',
  BULK: 'bulk',
} as const

/**
 * Price types
 */
export const PRICE_TYPES = {
  FIXED: 'fixed',
  VARIABLE: 'variable',
  INDEXED: 'indexed',
  FORMULA: 'formula',
} as const

/**
 * Channel types
 */
export const CHANNEL_TYPES = {
  B2B: 'b2b',
  ECOMMERCE: 'ecommerce',
} as const

/**
 * Default customer group codes
 */
export const DEFAULT_CUSTOMER_GROUPS = {
  ECOMMERCE: 'default-ecommerce',
  B2B: 'default-b2b',
} as const

/**
 * API endpoints
 */
export const PRICING_ENDPOINTS = {
  PROFILE: '/ecommerce/profile',
  PRODUCTS: '/ecommerce/catalog/products',
  PRODUCT_BY_ID: (documentId: string) => `/ecommerce/catalog/products/${documentId}`,
  PORTAL_PRODUCTS: '/catalog/products',
  PORTAL_PRODUCT_BY_ID: (documentId: string) => `/catalog/products/${documentId}`,
} as const
